import { Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { track } from "@/lib/track";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function mapLinks(item) {
  const q = encodeURIComponent(`${item.name}, ${item.address || ""}`);
  const ll = item.lat && item.lng ? `${item.lat},${item.lng}` : null;
  return [
    { id: "google", label: "Google Maps", href: `https://www.google.com/maps/dir/?api=1&destination=${q}` },
    { id: "apple", label: "Apple Maps", href: `https://maps.apple.com/?daddr=${q}` },
    { id: "waze", label: "Waze", href: ll ? `https://waze.com/ul?ll=${ll}&navigate=yes` : `https://waze.com/ul?q=${q}&navigate=yes` },
  ];
}

export function DirectionsMenu({ item, full }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button data-testid={`directions-button-${item.id}`} onClick={(e) => e.stopPropagation()}
          className={`rounded-full bg-white text-[#0B0F19] hover:bg-slate-200 font-semibold ${full ? "w-full h-12" : "h-9"}`}>
          <Navigation className="h-4 w-4 mr-1.5" /> Directions
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="bg-[#151C2C] border-[#26334D] text-white" onClick={(e) => e.stopPropagation()}>
        {mapLinks(item).map((m) => (
          <DropdownMenuItem key={m.id} asChild>
            <a data-testid={`directions-${m.id}-${item.id}`} href={m.href} onClick={() => track(item, "directions")} target="_blank" rel="noopener noreferrer" className="cursor-pointer">
              Open in {m.label}
            </a>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
